// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'webcam';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinejoin='round'>
    <g strokeLinecap='round'>
      <path d='M13.468 13.203c-.75 1.11.313 3.235 1.376 3.766H3.156c1.063-.531 2.125-2.656 1.376-3.766M9 11.125A3.187 3.187 0 1 0 9 4.75a3.187 3.187 0 0 0 0 6.375z' />
      <path d='M9 14.844A6.906 6.906 0 1 0 9 1.03a6.906 6.906 0 0 0 0 13.813z' />
    </g>
    <path d='M9 8.203a.266.266 0 1 1 0-.531m0 .531a.266.266 0 1 0 0-.531' />
  </g>
);

export const viewBox = '0 0 18 18';
